import React from 'react';
import { Shield, Droplets, Leaf } from 'lucide-react';
import { SectionHeader } from '../ui/Shared';
export function SolutionSection() {
  const pillars = [{
    icon: <Droplets className="w-6 h-6 text-accent" data-id="element-334" />,
    title: 'Claridad',
    desc: 'Saber qué hacer exactamente durante 72 horas para reducir el caos digestivo.'
  }, {
    icon: <Shield className="w-6 h-6 text-accent" data-id="element-335" />,
    title: 'Sin improvisar',
    desc: 'Sin probar cien cosas. Solo pasos simples que te devuelven control.'
  }, {
    icon: <Leaf className="w-6 h-6 text-accent" data-id="element-336" />,
    title: 'Resultados',
    desc: 'Reducir el ardor, dormir mejor y comer con más tranquilidad.'
  }];
  return <section id="solucion" className="py-24 bg-surface" data-id="element-337">
      <div className="max-w-[780px] mx-auto px-6" data-id="element-338">
        <SectionHeader tag="La solución" title={<>
              Por eso existe
              <br data-id="element-340" />
              Reflujo Cero en 72h
            </>} data-id="element-339" />

        <div className="fade-up bg-surface-2/40 border border-white/5 rounded-xl p-6 md:p-8 mt-8 mb-10 text-center" data-id="element-341">
          <p className="text-lg text-text-light font-semibold mb-3" data-id="element-342">
            Un protocolo simple para reducir el ardor, bajar la presión
            digestiva y recuperar control.
          </p>
        </div>

        <div className="scale-in bg-gradient-to-br from-surface-2 to-accent/5 border border-accent/25 rounded-2xl p-8 md:p-12 mt-10 relative overflow-hidden" data-id="element-343">
          {/* Decorative circle */}
          <div className="absolute top-0 right-0 w-48 h-48 bg-[radial-gradient(circle,rgba(232,160,32,0.1),transparent)] rounded-full" data-id="element-344" />

          <div className="relative z-10" data-id="element-345">
            <h3 className="font-playfair text-2xl md:text-3xl text-accent mb-6 font-bold" data-id="element-346">
              Lo que realmente estás comprando
            </h3>

            <div className="space-y-6" data-id="element-347">
              {pillars.map((pillar, idx) => <div key={idx} className="flex gap-5 items-start" data-id="element-348">
                  <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center shrink-0 border border-accent/20" data-id="element-349">
                    {pillar.icon}
                  </div>
                  <div data-id="element-350">
                    <h4 className="text-lg font-bold text-text-light mb-1" data-id="element-351">
                      {pillar.title}
                    </h4>
                    <p className="text-text-muted leading-relaxed" data-id="element-352">
                      {pillar.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}